import React from "react";
import { Chart } from "react-google-charts";

interface InputValues {
    data: any
    options: any
}



export function BubbleChart({data, options}: InputValues) {
    return (
        <Chart
            chartType="BubbleChart"
            width="100%"
            height="600px"
            data={data}
            options={options}
        />
    );
}
